import React from 'react';
import LazyCohortVisualisation from './LazyCohortVisualisation';
import CohortVisualisationMenu from '../containers/CohortVisualisationMenu';
import CohortQueryMenu from '../../queries/containers/CohortQueryMenu';

const CohortVisualisationCompact = ({
  code,
  category,
  allowCohortVisualisations,
  queryAccess,
  chartType,
  selectChart,
}) => (
  <>
    {queryAccess && (
      <CohortQueryMenu code={code} category={category} />
    )}
    {allowCohortVisualisations && (
      <>
        <CohortVisualisationMenu
          code={code}
          category={category}
          chartType={chartType}
          selectChart={selectChart}
          compact
        />
        <LazyCohortVisualisation code={code} category={category} chartType={chartType} />
      </>
    )}
  </>
);

export default CohortVisualisationCompact;
